(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RemoteStorage", [], factory);
	else if(typeof exports === 'object')
		exports["RemoteStorage"] = factory();
	else
		root["RemoteStorage"] = factory();
})(this, function() {
return 